import type {OmitStrict} from 'type-zoo'
import type {TMinorActionDataPayOther} from '@kapitalist/contract/types'
import MinorActionPaySomething from '~/models/game/MinorActions/MinorActionPaySomething'

type PublicMembersFromApi = OmitStrict<TMinorActionDataPayOther, 'type' | 'paidWith'>

// Paying off a Debt Collector or Birthday
export default class MinorActionPayOther
  extends MinorActionPaySomething<TMinorActionDataPayOther>
  implements PublicMembersFromApi {}
